"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.DetailGalleryItemType = void 0;
var DetailGalleryItemType;
(function (DetailGalleryItemType) {
    DetailGalleryItemType[DetailGalleryItemType["VR"] = 1] = "VR";
    DetailGalleryItemType[DetailGalleryItemType["VIDEO"] = 2] = "VIDEO";
    DetailGalleryItemType[DetailGalleryItemType["IMAGE"] = 3] = "IMAGE";
    DetailGalleryItemType[DetailGalleryItemType["FLOORPLAN"] = 4] = "FLOORPLAN";
})(DetailGalleryItemType = exports.DetailGalleryItemType || (exports.DetailGalleryItemType = {}));
